import workflowReducer from "modules/workflow/reducer";

const reducers = {
  workflow: workflowReducer,
};

export default reducers;
